// extracted by mini-css-extract-plugin
export default {"reason":"style_reason__xIxPe","icon":"style_icon__a-b99","status":"style_status__mjgLJ","text":"style_text__raemS"};